export const TW_ACC_KEY = "twitterAccountKey";
export const TW_VERIFY_TOKEN = "twitterVerifyToken";
export const TW_VERIFY_SECRET = "twitterVerifySecret";
export const FB_ACC_KEY = "facebookAccountKey";
export const FB_REDIRECT_URL = "facebookRedirectUrl";
export const YT_ACC_KEY = "youtubeAccountKey";
export const YT_REDIRECT_URL = "youtubeRedirectUrl";
export const SESSION_STORAGE_KEY = "media.spot-on.session";
export const SESSION_SELECTED_PROJECT = "media.spot-on.session.project";
export const SESSION_SELECTED_USER_PROJECTS =
    "media.spot-on.session.userhasmultipleprojects";
export const SESSION_SELECTED_USER_ROLES = "media.spot-on.session.userroles";
export const SESSION_SELECTED_VERIFIED = "media.spot-on.session.verified";
export const CAPTIONS_LANG_PREF = "media.spot-on.captions.language";
export const ONBOARDING = "media.spot-on.onboarding";
